<template>
  <div class="chat-history-item" :class="active ? 'active' : ''">
    <div class="message-normal">
      <div class="avatar">
        <head-image :name="showName" :size="38" :url="headImage" :id="msgInfo.sendId"></head-image>
      </div>
      <div class="content">
        <div class="top">
          <span>{{ showName }}</span>
          <span>{{ $date.toTimeText(msgInfo.sendTime) }}</span>
        </div>
        <div class="bottom">
          <div ref="chatMsgBox">
            <span class="message-text" v-if="msgInfo.type == $enums.MESSAGE_TYPE.TEXT" v-html="htmlText"></span>
            <!-- 新增红包消息 -->
            <red-pack-card v-else-if="msgInfo.type == $enums.MESSAGE_TYPE.RED_PACKET" :msgInfo="msgInfo" class="new-red-pack-card" />
            <div class="message-image" v-if="msgInfo.type == $enums.MESSAGE_TYPE.IMAGE">
              <div v-loading="sending" element-loading-text="发送中.." element-loading-background="rgba(0, 0, 0, 0.4)">
                <img class="send-image" :src="JSON.parse(msgInfo.content).thumbUrl" @click="showFullImageBox()" loading="lazy" />
              </div>
            </div>
            <div class="message-video" v-if="msgInfo.type == $enums.MESSAGE_TYPE.VIDEO">
              <video
                ref="videoPlayer"
                class="send-video"
                controls
                preload="none"
                :poster="JSON.parse(msgInfo.content).coverUrl"
                :src="JSON.parse(msgInfo.content).videoUrl"
              />
            </div>
            <div class="message-file" v-if="msgInfo.type == $enums.MESSAGE_TYPE.FILE">
              <div class="chat-file-box" v-loading="sending">
                <div class="chat-file-info">
                  <el-link
                    class="chat-file-name"
                    :underline="true"
                    target="_blank"
                    type="primary"
                    :href="contentData.url"
                    :download="contentData.name"
                    >{{ contentData.name }}</el-link
                  >
                  <div class="chat-file-size">{{ fileSize }}</div>
                </div>
                <div class="chat-file-icon">
                  <span type="primary" class="el-icon-document"></span>
                </div>
              </div>
            </div>
          </div>
          <chat-user-card v-if="msgInfo.type == $enums.MESSAGE_TYPE.USER_CARD" :cardInfo="contentData"></chat-user-card>
          <chat-group-card
            v-if="msgInfo.type == $enums.MESSAGE_TYPE.GROUP_CARD"
            :cardInfo="contentData"
            :sendTime="msgInfo.sendTime"
          ></chat-group-card>
          <!-- <div class="message-voice" v-if="msgInfo.type == $enums.MESSAGE_TYPE.AUDIO" @click="onPlayVoice()"> -->
          <div class="message-voice" v-if="msgInfo.type == $enums.MESSAGE_TYPE.AUDIO">
            <!-- <audio controls :src="JSON.parse(msgInfo.content).url"></audio> -->
            <audio
              ref="audioPlayer"
              :src="contentData.url"
              @play="onAudioPlay"
              @canplaythrough="Audiothrough"
              controls
              preload="metadata"
              crossorigin="anonymous"
            ></audio>
          </div>
          <div class="quote-message" v-if="msgInfo.quoteMessage">
            <chat-quote-message :msgInfo="msgInfo.quoteMessage" :showName="quoteShowName"></chat-quote-message>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import ChatQuoteMessage from "./ChatQuoteMessage.vue";
import ChatUserCard from "./ChatUserCard.vue";
import ChatGroupCard from "./ChatGroupCard.vue";
import RedPackCard from "../common/RedPackCard.vue";

export default {
  name: "chatHistoryItem",
  components: {
    HeadImage,
    ChatQuoteMessage,
    ChatUserCard,
    ChatGroupCard,
    RedPackCard
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    headImage: {
      type: String,
      default: ""
    },
    showName: {
      type: String,
      required: true
    },
    quoteShowName: {
      type: String,
      default: ""
    },
    msgInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      audio: null
    };
  },
  created() {
    // 监听其他音频播放事件，停止当前音频
    this.$eventBus.$on("audioPlaying", this.stopAudio);
  },
  beforeDestroy() {
    // 清理事件监听
    this.$eventBus.$off("audioPlaying", this.stopAudio);
    this.stopAudio();
  },
  methods: {
    showFullImageBox() {
      let imageUrl = JSON.parse(this.msgInfo.content).originUrl;
      if (imageUrl) {
        this.$eventBus.$emit("openFullImage", imageUrl);
      }
    },
    onPlayVoice() {
      if (!this.audio) {
        this.audio = new Audio();
      }
      this.audio.src = JSON.parse(this.msgInfo.content).url;
      this.audio.play();
      this.onPlayVoice = "RUNNING";
    },
    onAudioPlay(e) {
      // 广播当前音频开始播放的事件
      this.$eventBus.$emit("audioPlaying", { msgId: this.msgInfo.id });
      // 不再需要isPlaying状态，因为原生audio控件会自行处理播放状态显示
    },

    // 音频时长处理，因为.MP3 显示不了总时长，而.wav可以
    async Audiothrough(e) {
      const audio = e.target;
      const audioDuration = audio.duration;
      if (audioDuration === Infinity) {
        audio.currentTime = 1e101;
        audio.ontimeupdate = () => {
          audio.ontimeupdate = () => {
            return;
          };
          audio.currentTime = 1e101;
          audio.currentTime = 0;
        };
      }
    },

    stopAudio(data) {
      // 如果不是当前消息触发的停止事件，则停止当前音频
      if (!data || data.msgId !== this.msgInfo.id) {
        if (this.$refs.audioPlayer) {
          this.$refs.audioPlayer.pause();
          // 重置到开始位置不是必须的，但可以保留
          // this.$refs.audioPlayer.currentTime = 0;
        }
      }
    }
  },
  computed: {
    sending() {
      return this.msgInfo.status == this.$enums.MESSAGE_STATUS.SENDING;
    },
    contentData() {
      return JSON.parse(this.msgInfo.content);
    },
    fileSize() {
      let size = this.contentData.size;
      if (size > 1024 * 1024) {
        return Math.round(size / 1024 / 1024) + "M";
      }
      if (size > 1024) {
        return Math.round(size / 1024) + "KB";
      }
      return size + "B";
    },
    htmlText() {
      let text = this.$str.html2Escape(this.msgInfo.content);
      text = this.$url.replaceURLWithHTMLLinks(text, "");
      return this.$emo.transform(text, "emoji-normal");
    }
  }
};
</script>

<style lang="scss">
.chat-history-item {
  padding: 2px 8px;
  width: 620px;
  cursor: pointer;
  border-radius: 10px;
  margin-right: 20px;

  &:hover {
    background: var(--im-background-active);
  }

  &.active {
    background: var(--im-background-active-dark);
  }

  .message-normal {
    position: relative;
    font-size: 0;
    padding-left: 48px;
    min-height: 50px;
    margin: 5px 0;

    .avatar {
      position: absolute;
      width: 40px;
      height: 40px;
      top: 0;
      left: 0;
    }

    .content {
      text-align: left;

      .top {
        display: flex;
        flex-wrap: nowrap;
        color: var(--im-text-color-light);
        font-size: var(--im-font-size);
        line-height: 20px;

        span {
          margin-right: 12px;
        }
      }

      .bottom {
        padding-right: 100px;
        margin-top: 1px;

        .message-text {
          display: inline-block;
          position: relative;
          line-height: 26px;
          border-radius: 10px;
          font-size: var(--im-font-size);
          text-align: left;
          white-space: pre-wrap;
          word-break: break-word;
        }

        .message-image {
          display: flex;
          flex-wrap: nowrap;
          flex-direction: row;
          align-items: center;

          .send-image {
            min-width: 100px;
            min-height: 75px;
            max-width: 200px;
            max-height: 150px;
            border-radius: 8px;
          }
        }

        .message-video {
          display: flex;
          flex-wrap: nowrap;
          flex-direction: row;
          align-items: center;

          .send-video {
            min-width: 100px;
            min-height: 75px;
            max-width: 200px;
            max-height: 150px;
            border-radius: 8px;
            overflow: hidden;
            object-fit: contain;
          }
        }

        .message-file {
          display: flex;
          flex-wrap: nowrap;
          flex-direction: row;
          align-items: center;
          margin-bottom: 2px;

          .chat-file-box {
            display: flex;
            flex-wrap: nowrap;
            align-items: center;
            box-shadow: var(--im-box-shadow-light);
            border-radius: 4px;
            padding: 8px 15px;

            .chat-file-info {
              flex: 1;
              height: 100%;
              text-align: left;
              font-size: 14px;
              margin-right: 10px;

              .chat-file-name {
                display: inline-block;
                min-width: 160px;
                max-width: 400px;
                font-size: 14px;
                margin-bottom: 4px;
                white-space: pre-wrap;
                word-break: break-all;
              }

              .chat-file-size {
                font-size: var(--im-font-size-smaller);
                color: var(--im-text-color-light);
              }
            }

            .chat-file-icon {
              font-size: 34px;
              color: #d42e07;
            }
          }
        }

        .message-voice audio {
          height: 45px;
        }

        .quote-message {
          display: block;
          margin-top: 3px;
          cursor: pointer;
        }
      }
    }
  }
}
// 红包卡片 样式覆盖 父组件
.new-red-pack-card {
  .rp-left {
    width: 50px !important;
    height: 50px !important;
  }
  /* 红包图标（使用现有 iconfont） */
  .rp-icon {
    font-size: 30px !important;
  }
  /* 底部品牌条（与卡片同宽） */
  .rp-brand {
    background: #f7f8fa !important;
  }

  /* 标题（红包名称） */
  .rp-title {
    font-size: 15px !important;
  }

  /* 副文 */
  .rp-sub {
    font-size: 12px !important;
  }
}
</style>
